import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link, useParams } from "react-router-dom";

const ViewSubHeading = () => {
     useAuthRedirect();
    const { id, headingg, sHeading } = useParams();
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [heading, setHeading] = useState("");

    useEffect(() => {
        fetchData();
    }, [headingg, sHeading]); 
    
   const fetchData = async () => {
    setLoading(true);
    try {
        // Clean values
        let cleanHeading = headingg.trim().replace(/[\{\}]/g, "");
        let cleanSHeading = sHeading.trim();

        // Pass as query params
        const apiUrl = `https://rfs2.infraconsoft.net.in/api/fm_innerFinalList?heading=${encodeURIComponent(cleanHeading)}&sHeading=${encodeURIComponent(cleanSHeading)}`;
        const response = await axios.get(apiUrl);

        setHeading(response.data.heading);
        setData(response.data.subheadings);
        setFilteredData(response.data.subheadings);

    } catch (error) {
        if (error.response) {
            console.error("🚨 API Error Response:", error.response.data);
            console.error("🚨 Status Code:", error.response.status);
        } else if (error.request) {
            console.error("🚨 No Response Received:", error.request);
        } else {
            console.error("🚨 General Error:", error.message);
        }
    } finally {
        setLoading(false);
    }
};
 
    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);

        if (!term) {
            setFilteredData(data);
            return;
        }

        const filtered = data.filter((item) =>
            item.fld_subheading.toLowerCase().includes(term)
        );

        setFilteredData(filtered);
    };

    // Pagination
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <div id="admin-container">
            <InventoryNav />
            <div className="content-right">
                <section>
                                        <div className="back-div">
                    <h2 className="add-txt">Infraconsoft - {sHeading} Details </h2>
                    <Link to={`/inventory/viewheading`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
                    <Time />
                </section>

                {/* Search Filter */}
                <div className="search-filter">
                    <p>Search: </p>
                    <input
                        type="text"
                        placeholder="Search by Sub Heading"
                        value={searchTerm}
                        onChange={handleSearch}
                        className="search-input"
                    />
                </div>

                {/* Table */}
                <div className="content-table">
                    <table>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Sub Heading List</th>
                                <th>Go To</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="3" className="loading-text">
                                        Loading data, please wait...
                                    </td>
                                </tr>
                            ) : currentData.length > 0 ? (
                                currentData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{indexOfFirstItem + index + 1}</td>
                                        <td>{item.fld_innersubheading}</td>
                                        <td>
                                            <Link to={`/inventory/view_Filelisting/${id}/${headingg}/${sHeading}/${item.fld_innersubheading}`}>
                                                Go To
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3">No Data Available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        Previous
                    </button>

                    {/* Always show first page */}
                    <button onClick={() => paginate(1)} className={currentPage === 1 ? "active" : ""}>
                        1
                    </button>

                    {/* Show up to 3 pages dynamically */}
                    {filteredData.length > itemsPerPage &&
                        [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage)))].map((_, index) => {
                            const pageNumber = index + 2;
                            if (pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                                return (
                                    <button
                                        key={pageNumber}
                                        onClick={() => paginate(pageNumber)}
                                        className={currentPage === pageNumber ? "active" : ""}
                                    >
                                        {pageNumber}
                                    </button>
                                );
                            }
                            return null;
                        })}

                    {/* Next button */}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage >= Math.ceil(filteredData.length / itemsPerPage)}
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewSubHeading;
